import bw1 from '../../assets/img/logos/b&w/js.png';
import bw2 from '../../assets/img/logos/b&w/ruby.png';
import bw3 from '../../assets/img/logos/b&w/react.png';
import bw4 from '../../assets/img/logos/b&w/html.png';
import bw5 from '../../assets/img/logos/b&w/node.png';
import bw6 from '../../assets/img/logos/b&w/php.png';
import bw7 from '../../assets/img/logos/b&w/sql.png';
import bw8 from '../../assets/img/logos/b&w/docker.png';
import bw9 from '../../assets/img/logos/b&w/c-sharp.png';
import bw10 from '../../assets/img/logos/b&w/mongo.png';
import bw11 from '../../assets/img/logos/b&w/python.png';

export default [
  { src: bw1, height: 55 },
  { src: bw2, height: 55 },
  { src: bw3, height: 55 },
  { src: bw4, height: 55 },
  { src: bw5, height: 60 },
  { src: bw6, height: 65 },
  { src: bw7, height: 65 },
  { src: bw8, height: 65 },
  { src: bw9, height: 60 },
  { src: bw10, height: 60 },
  { src: bw11, height: 60 }
];
